import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store/index';
import { ID, ProductMenu } from '@/types/type';

export interface ISearchStore {
  resultList: ProductMenu[];
  searchTime: number;
}

@Module({ dynamic: true, store, name: 'searchstore', namespaced: true })
export default class SearchStore extends VuexModule implements ISearchStore {
  public resultList: ProductMenu[] = [];
  public searchTime: number = 0;

  @Mutation
  public setResults(list: ProductMenu[]) {
    this.resultList = list;
  }

  @Mutation
  public addFavorite(id: ID) {
    const index: number = this.resultList.findIndex((menu: ProductMenu) => {
      return menu.id === id;
    });
    const item: ProductMenu = this.resultList[index];
    item.isFavorite = true;
    this.resultList.splice(index, 1, item);
  }

  @Mutation
  public removeFavorite(id: ID) {
    const index: number = this.resultList.findIndex((menu: ProductMenu) => {
      return menu.id === id;
    });
    const item: ProductMenu = this.resultList[index];
    item.isFavorite = false;
    this.resultList.splice(index, 1, item);
  }

  public get results(): ProductMenu[] {
    return this.resultList;
  }

  @Mutation
  public setTime(time: number) {
    this.searchTime = time;
  }

  public get time(): number {
    return this.searchTime;
  }
}

export const searchModule = getModule(SearchStore);
